var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82.81mm",
    height: "52.736mm",
    viewBox: "0 0 82.81 52.736",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-66.034 -50.249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m107.44 50.249-41.403 41.403 11.324 11.324 30.076-30.076 30.085 30.085 11.324-11.324-30.085-30.085 2e-3 -0.0018z",
    strokeWidth: 0.26458
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.e63dcbe63e9d75ab1e41f0a6760d88b4.svg";
export { ForwardRef as ReactComponent };